module.exports = __webpack_public_path__ + "img/apiecobooster.5fbcef2a.jpg";